import { render, staticRenderFns } from "./MPlayBase.vue?vue&type=template&id=42ca23fe&scoped=true"
import script from "./MPlayBase.vue?vue&type=script&lang=js"
export * from "./MPlayBase.vue?vue&type=script&lang=js"
import style0 from "./MPlayBase.vue?vue&type=style&index=0&id=42ca23fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca23fe",
  null
  
)

export default component.exports